export type RawBook = { id: string; name?: string; hostId: string };

export interface AccessibleBook {
  id: string;
  name: string;
  hostId: string;
  isHost: boolean;
}

/** 호스트 book + 멤버 book 을 병합(중복 제거, 호스트 우선)하여 AccessibleBook 목록 반환 */
export function mergeAccessibleBooks(
  _uid: string,
  hostBooks: RawBook[],
  memberBooks: RawBook[],
): AccessibleBook[] {
  const byId = new Map<string, AccessibleBook>();
  for (const b of memberBooks) {
    byId.set(b.id, { id: b.id, name: b.name ?? '', hostId: b.hostId, isHost: false });
  }
  // 호스트가 멤버보다 우선 — 나중에 덮어쓴다
  for (const b of hostBooks) {
    byId.set(b.id, { id: b.id, name: b.name ?? '', hostId: b.hostId, isHost: true });
  }
  return Array.from(byId.values());
}

/** 선택된 book 에서 현재 uid 가 거래처를 편집할 수 있는가 (호스트만 true) */
export function canEditMerchants(book: AccessibleBook | null, uid: string | null): boolean {
  if (!book || !uid) return false;
  return book.isHost && book.hostId === uid;
}
